import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import StatsKpis from "@/components/stats/StatsKpis";
import EventBars from "@/components/stats/EventBars";
import DailyChart from "@/components/stats/DailyChart";
import LeadsTable from "@/components/stats/LeadsTable";

const API = process.env.REACT_APP_BACKEND_URL;

export default function StatsPage() {
  const [data, setData] = useState(null);
  const [leads, setLeads] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [s, l] = await Promise.all([fetch(`${API}/api/stats`), fetch(`${API}/api/leads`)]);
      if (!s.ok || !l.ok) throw new Error("bad status");
      setData(await s.json());
      setLeads(await l.json());
      setError("");
    } catch (e) {
      setError("No se pudieron cargar las estadísticas. Intenta de nuevo.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    document.title = "Contador de clics — MenuThere";
    const meta = document.createElement("meta");
    meta.name = "robots"; meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
    load();
    const id = setInterval(load, 30000);
    return () => { clearInterval(id); meta.remove(); };
  }, [load]);

  const updated = data ? new Date(data.generated_at).toLocaleString("es-MX", { dateStyle: "medium", timeStyle: "short" }) : "";

  return (
    <div className="stats-page" data-testid="stats-page">
      <header className="stats-header">
        <Link to="/" data-testid="stats-back-link" className="stats-back">
          <img src="/images/menuthere-logo-full-new.svg" alt="MenuThere" style={{ height: 36 }} />
        </Link>
        <div className="stats-header-right">
          <span className="stats-live" data-testid="stats-live-badge"><span className="stats-live-dot" /> En vivo · se actualiza cada 30 s</span>
          <button onClick={load} disabled={loading} className="stats-refresh" data-testid="stats-refresh-button">
            <i className={`fas fa-sync-alt ${loading ? "fa-spin" : ""}`} /> Actualizar
          </button>
        </div>
      </header>

      <main className="stats-main">
        <div className="stats-title-row">
          <div>
            <p className="stats-eyebrow">Landing · MenuThere México</p>
            <h1 className="stats-title">Contador de clics y leads</h1>
          </div>
          {updated && <p className="stats-updated" data-testid="stats-updated-at">Última actualización: {updated}</p>}
        </div>

        {error && <div className="stats-error" data-testid="stats-error">{error}</div>}

        {data && (
          <>
            <StatsKpis data={data} leads={leads} />
            <div className="stats-grid">
              <EventBars events={data.events} total={data.total} />
              <DailyChart daily={data.daily} />
            </div>
            {leads && <LeadsTable leads={leads} />}
          </>
        )}
        {!data && !error && <p className="stats-loading" data-testid="stats-loading">Cargando…</p>}
      </main>
    </div>
  );
}
